import { ApiSlugs, JobConfigDto, JobConfigId, QueueNames, UpdateJobConfigDto } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';

export class JobConfigsAdminConnector extends ApiConnector<JobConfigDto, JobConfigDto, JobConfigId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.JOB_CONFIGS);
  }

  getPendingCounts(): Observable<Record<string, number>> {
    return this.apiCaller.getRequest<Record<string, number>>(this.apiPrefix, `${this.slug}/pending-counts`);
  }

  getAllConfigs(): Observable<JobConfigDto[]> {
    return this.apiCaller.getRequest<JobConfigDto[]>(this.apiPrefix, `${this.slug}/all`);
  }

  getByQueueName(queueName: QueueNames): Observable<JobConfigDto> {
    return this.apiCaller.getRequest<JobConfigDto>(this.apiPrefix, `${this.slug}/${queueName}`);
  }

  updateConfig(queueName: QueueNames, dto: UpdateJobConfigDto): Observable<JobConfigDto> {
    return this.apiCaller.patchRequest<JobConfigDto, UpdateJobConfigDto>(
      this.apiPrefix,
      `${this.slug}/${queueName}`,
      dto,
    );
  }
}
